export default __webpack_public_path__ + "static/media/not-allowed.baeb42e6.svg";